import { i18n } from '@/plugins/i18n'
import { statusVariant, statusStr } from '@/constants/settlementStatus'

export default [
    {
        field: 'id',
        title: i18n.t('label.settlement_id'),
        sortable: true,
        width: 65,
        selector: false,
        textAlign: 'left', // in rtl version means right
    },
    {
        field: 'full_name',
        title: i18n.t('label.user_full_name'),
        textAlign: 'left',
        template: (row) => {
            return '<a href="/users/' + row.user_id + '/details">'+row.full_name+'</a>'
        },
        sortable: true,
    },
    {
        field: 'amount',
        title: i18n.t('label.amount') + " (" + i18n.t('currency.rial') + ")",
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'wage',
        title: i18n.t('label.wage'),
        width: 90,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'website_address',
        title: i18n.t('label.website_address'),
        width: 80,
        sortable: false,
        template: (row) => {
            return '<a href="/gateways/' + row.shop_id + '/details">'+row.website_address+'</a>'
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.date_created'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('label.settlement_type'),
        sortable: true,
        width: 60,
        textAlign: 'center',
        template: (row) => {
            let variant, type
            if (row.type == 0) {
                variant = 'badge-success'
                type    = i18n.t('label.payment_helper')
            } else if (row.type == 1) {
                variant = 'badge-success'
                type    = i18n.t('label.payman')
            } else if (row.type == 2) {
                variant = 'badge-success'
                type    = i18n.t('label.ivr')
            } else if (row.type == 3) {
                variant = 'badge-success'
                type    = i18n.t('label.allotment')
            }

            return '<div class="badge '+variant+' text-white">'+ type +'</div>'
        },
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        width: 80,
        textAlign: 'center',
        template: (row) => {
            let variant   = 'badge-'+statusVariant(row.status)
            let status = statusStr.get(row.status)

            return '<div class="badge '+variant+' text-white">'+ status +'</div>'
        },
        sortable: true,
    },
]